import { render, staticRenderFns } from "./Inscripcion.vue?vue&type=template&id=b74d3c42&scoped=true"
import script from "./Inscripcion.vue?vue&type=script&lang=js"
export * from "./Inscripcion.vue?vue&type=script&lang=js"
import style0 from "./Inscripcion.vue?vue&type=style&index=0&id=b74d3c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74d3c42",
  null
  
)

export default component.exports